import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../features/axiosHelper";
import { Box, Button, Card, Container, Typography } from "@mui/material";
import MainNavigation from "@/components/MainNavigation/MainNavigation";
import CardDataGrid, {
  GridLogicOperator,
  RenderStatus,
} from "@/components/DataGrid/CardDataGrid";
import { Link } from "react-router-dom";
import Dropdown from "@/components/Dropdown/Dropdown";
import { MenuItemEnum } from "@/utils/utils";
import ShepDataGridPro from "@/components/shared/ShepDataGridPro";
import { importStatusEnum } from "@/features/maintenance/fileImportSlice";
import { GridActionsCellItem } from "@mui/x-data-grid";
import {
  ShepCheckbox,
  ShepTooltip,
  ShepHorizontalMenu,
  ShepPagination,
} from "@/components/GenericComponents/ShepComponents";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  ProcessStatusSuccess,
  ProcessStatusError,
  ProcessStatusProcessing,
  ProcessStatusNotQueued,
} from "../../ImageRepo";
dayjs.extend(utc);

const Notifications = () => {
  const navigate = useNavigate();
  const [statusFilter, setStatusFilter] = useState("");
  const [stageFilter, setStageFilter] = useState([]);
  const [dataCapInc, setdataCapInc] = useState(1);
  const [sort, setSort] = useState([]);
  const [rows, setRows] = useState([]);

  const gridHeaderSx = {
    "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader:hover": {
      borderBottomLeftRadius: "4px",
      borderBottomRightRadius: "4px",
      backgroundColor: "var(--primary-pale)",
      borderBottom: "none",
      borderLeft: "none",
    },
    color: "var(--text-primary)",
    fontSize: "var(--font-sm)",
    fontFamily: "var(--font-family)",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    backgroundColor: "var(--default-light)",
    border: "none",
    "& .MuiDataGrid:hover": {
      backgroundColor: "inherit",
    },
    "& .MuiDataGrid-cellCheckbox, & .workflow-row": {
      opacity: 0,
      borderBottom: "none",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "none",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "var(--tertiary-13)",
    },
    "& .workflow-row:hover": {
      backgroundColor: "transparent",
    },
    "& .Mui-selected": {
      backgroundColor: "var(--primary-pale)",
    },
    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader.MuiDataGrid-columnHeaderCheckbox":
      {
        outline: "none",
      },
    "& .MuiDataGrid-row:hover .MuiDataGrid-cellCheckbox, & .MuiDataGrid-row:hover .workflow-row":
      {
        opacity: 1,
      },
    "& .MuiDataGrid-cellCheckbox": {
      borderLeft: "8px solid transparent",
    },
    "& .Mui-selected .MuiDataGrid-cellCheckbox": {
      opacity: 1,
      borderLeft: "8px solid var(--primary-main)",
      borderTopLeftRadius: "4px",
      borderBottomLeftRadius: "4px",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontSize: "var(--font-md)",
      fontWeight: "var(--font-bold)",
      borderLeft: "none",
    },
    "& .MuiCheckbox-root": {
      display: "block",
      paddingBottom: "20px",
    },
  };

  const gridRef = useRef(null);
  const columns = [
    {
      field: "TimestampUTC",
      headerName: "Date / Time",
      width: 175,
      renderCell: (params) =>
        dayjs.utc(params.row.LogTimeUTC).local().format("YYYY.MM.DD HH:mm"),
    },
    {
      field: "DocumentReference",
      headerName: "Reference No.",
      width: 190,
    },
    {
      field: "SeverityLabel",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        return RenderStatus(params.value);
      },
    },
    {
      field: "Message",
      headerName: "Message",
      width: 100,
      flex: 1,
    },
  ];

  useEffect(() => {
    getNotifications();
  }, [statusFilter, stageFilter, dataCapInc, sort]);

  const getNotifications = () => {
    let params = {
      statusFilter: statusFilter,
      stageFilterJson: JSON.stringify(stageFilter),
      dataCapInc: dataCapInc,
    };
    if (sort.length > 0) {
      params.sortField = sort[0].field;
      params.sortAsc = sort[0].sort == "asc";
    }
    axios
      .get("/notifications", {
        params: params,
      })
      .then((response) => {
        const responseData = response.data;
        setNotificationGridLoaded(true);
        setRows(responseData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const statusOptions = [
    { key: "Error", label: "Error" },
    { key: "Warning", label: "Warning" },
    { key: "Success", label: "Success" },
  ];
  const stageOptions = [
    { key: "101010", label: "New Orders for Customer" },
    { key: "101020", label: "101020" },
    { key: "101030", label: "101030" },
  ];

  const onSelectStatus = (event, data) => {
    let status = event.target.value;

    //Don't change state if clicking on an action
    if (status === "dropdown-action") return;

    setStatusFilter(status);
    setdataCapInc(1);
  };

  const onSelectStage = (event) => {
    let stages = event.target.value;
    setStageFilter(stages);
    setdataCapInc(1);

    // //Set Grid Filter
    let gridFilterModel = gridRef.current.getGridFilter();
    let newFilter = gridFilterModel.items.filter((f) => {
      return f.field !== "stage";
    });

    if (stages !== "") {
      newFilter.push({
        id: "stage",
        field: "stage",
        operator: "isAnyOf",
        value: stages,
      });
    }
    // Migrated to back end
    // gridRef.current.setGridFilter({
    //   items: newFilter,
    //   logicOperator: GridLogicOperator.And,
    // });
  };

  const actionOnClick = () => {
    alert("Dropdown action was clicked");
  };
  const onHitDataCap = () => {
    setdataCapInc(dataCapInc + 1);
  };

  //Notification functions-------//

  const [notificationGridLoaded, setNotificationGridLoaded] = useState(false);

  //File Import functions-------//
  const [importLogs, setImportLogs] = useState([]);
  const [importLogsLoaded, setImportLogsLoaded] = useState(false);

  const actions = [
    {
      label: "Notifications Configuration",
      onClick: () => navigate("/notification-config"),
    },
  ];

  const importLogColumns = [
    { field: "FileName", headerName: "File Name", width: 250 },
    {
      field: "LogTimeUTC",
      headerName: "Date / Time",
      width: 180,
      renderCell: (params) =>
        dayjs.utc(params.row.LogTimeUTC).local().format("YYYY.MM.DD HH:mm"),
    },
    {
      field: "Status",
      headerName: "Status",
      width: 265,
      renderCell: (params) => {
        let text = "";
        let icon = null;
        if (params.row.Status === importStatusEnum.Queued) {
          text = "Queued";
          icon = (
            <img
              alt="pending"
              src={ProcessStatusProcessing}
              style={{ height: 20, verticalAlign: "middle" }}
            />
          );
        } else if (params.row.Status === importStatusEnum.Completed) {
          text = "Completed";
          icon = (
            <img
              alt="success"
              src={ProcessStatusSuccess}
              style={{ height: 20, verticalAlign: "middle" }}
            />
          );
        } else if (
          params.row.Status === importStatusEnum.CompletedWithWarning
        ) {
          text = "Completed With Warning";
          icon = (
            <img
              alt="warning"
              src={ProcessStatusSuccess}
              style={{ height: 20, verticalAlign: "middle" }}
            />
          );
        } else if (params.row.Status === importStatusEnum.Processing) {
          text = "Processing";
          icon = (
            <img
              alt="pending"
              src={ProcessStatusProcessing}
              style={{ height: 20, verticalAlign: "middle" }}
            />
          );
        } else if (params.row.Status === importStatusEnum.Cancelled) {
          text = "Cancelled";
          icon = (
            <img
              alt="error"
              src={ProcessStatusNotQueued}
              style={{ height: 20, verticalAlign: "middle" }}
            />
          );
        } else {
          text = "Failed";
          icon = (
            <img
              alt="error"
              src={ProcessStatusError}
              style={{ height: 20, verticalAlign: "middle" }}
            />
          );
        }
        return (
          <span style={{ display: "flex", alignItems: "center" }}>
            {icon}
            <span style={{ marginLeft: 8 }}>{text}</span>
          </span>
        );
      },
    },
    {
      field: "progress",
      headerName: "Progress %",
      width: 180,

      renderCell: (params) => {
        const jsonDetails = params.row.JSONDetails ?? "{}";
        const details = JSON.parse(jsonDetails);

        if (params.row.Status === importStatusEnum.Processing) {
          return details.ProgressPercent + "%";
        }
        if (
          params.row.Status === importStatusEnum.Completed ||
          params.row.Status === importStatusEnum.CompletedWithWarning
        ) {
          return "100%";
        } else return "";
      },
    },
    {
      field: "lastUpdated",
      headerName: "Last Updated",
      width: 205,

      renderCell: (params) => {
        const jsonDetails = params.row.JSONDetails ?? "{}";
        const details = JSON.parse(jsonDetails);
        return (
          dayjs
            .utc(details.LastUpdatedUTC)
            .local()
            .format("YYYY.MM.DD HH:mm") ?? ""
        );
      },
    },
    {
      field: "message",
      headerName: "Message",
      width: 200,
      flex: 7,
      renderCell: (params) => {
        const jsonDetails = params.row.JSONDetails ?? "{}";
        const details = JSON.parse(jsonDetails);
        return details.Message ?? "";
      },
    },
    {
      field: "threedotMenu",
      type: "actions",
      getActions: (params) => [
        <GridActionsCellItem
          label="Cancel"
          showInMenu
          disabled={
            params.row.Status !== importStatusEnum.Queued &&
            params.row.Status !== importStatusEnum.Processing
          }
          id="single-grid-action"
          onClick={() => handleCancelRecord({ params })}
        />,
      ],
    },
  ];
  useEffect(() => {
    fetchRecentFileImportLogs();
  }, []);
  useEffect(() => {
    const existsInProgress = importLogs.find(
      (x) => x.Status === importStatusEnum.Processing
    );
    if (existsInProgress !== undefined) {
      const timer = setTimeout(() => {
        fetchRecentFileImportLogs();
      }, 120000); //2 mins
      return () => clearTimeout(timer);
    }
  }, [importLogs]);

  const fetchRecentFileImportLogs = async () => {
    await axios.get("/fileimport/logs").then((response) => {
      setImportLogs(response.data);
      setImportLogsLoaded(true);
    });
  };

  const handleCancelRecord = async ({ params }) => {
    const fileImportId = params.row.FileImportId;
    const fileName = params.row.FileName;
    await axios
      .post("/fileimport/cancel", null, {
        params: { fileImportId, fileName },
      })
      .then(() => {
        fetchRecentFileImportLogs();
      });
  };

  //---------------------------//

  return (
    <Container>
      <MainNavigation selected={MenuItemEnum.Notifications} />

      <Box
        className="content-container"
        style={{
          boxSizing: "border-box",
        }}
      >
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Dropdown
            width={300}
            label="Status Filter"
            onChange={onSelectStatus}
            value={statusFilter}
            options={statusOptions}
            //actionLabel="+ Dropdown Action"
            //actionOnClick={actionOnClick}
          ></Dropdown>
          <ShepHorizontalMenu actions={actions} />
        </Box>

        <Container
          sx={{
            height: "78px",
            backgroundColor: "var(--primary-main)",
            color: "var(--default-light)",
            padding: "20px 0px 20px 40px",
            borderRadius: "4px",
            boxSizing: "border-box",
            display: "flex",
            alignItems: "center",
            marginTop: "24px",
            marginBottom: "12px",
          }}
        >
          <Typography variant="h4">Notifications</Typography>
        </Container>
        <CardDataGrid
          isDataLoaded={notificationGridLoaded}
          ref={gridRef}
          rows={rows}
          columns={columns}
          whiteHeader={true}
          checkboxSelection={false}
          onHitDataCap={onHitDataCap}
          onSortChange={setSort}
          rowHeight={40}
        />
        <Box sx={{ marginTop: "50px" }}>
          <Container
            sx={{
              height: "78px",
              backgroundColor: "var(--primary-main)",
              color: "var(--default-light)",
              padding: "20px 0px 20px 40px",
              borderRadius: "4px",
              boxSizing: "border-box",
              display: "flex",
              alignItems: "center",
              marginTop: "24px",
              marginBottom: "12px",
            }}
          >
            <Typography variant="h4">File Import Status</Typography>
          </Container>
          <ShepDataGridPro
            isDataLoaded={importLogsLoaded}
            secondsToStall={4}
            rows={importLogs}
            columns={importLogColumns}
            getRowId={(row) => row.FileImportLogId}
            pagination
            slots={{
              pagination: ShepPagination,
              baseCheckbox: ShepCheckbox,
              baseTooltip: ShepTooltip,
            }}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 15, page: 0 },
              },
            }}
            sx={gridHeaderSx}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default Notifications;
